export const kpiBoxCardTypes = {
    fearAndGreed: '1',
    bullBearRatio: '2',
    vix: '3',
    interestRate: '4',
    consumerSentiment: '5',
    usInflationRate: '6',
    fedInterestRate: '7',
    initialClaims: '8'
}

export const initMarketAnalysisKpiCardsConfiguration = [
    kpiBoxCardTypes.fearAndGreed,
    kpiBoxCardTypes.vix,
    kpiBoxCardTypes.consumerSentiment,
    kpiBoxCardTypes.usInflationRate,
]

export const tabConstants = {
    report: 'report',
    personalized: 'personalized',
    sector: 'sector',
    data: 'data',
}

export const sectorTabConstants = {
    basicMaterials: 'basic-materials',
    communicationServices: 'communication-services',
    consumerCyclical: 'consumer-cyclical',
    consumerDefensive: 'consumer-defensive', 
    energy: 'energy',
    financialServices: 'financial-services',
    healthcare: 'healthcare',
    industrials: 'industrials',
    realEstate: 'real-estate',
    technology: 'technology',
    utilities: 'utilities',
}

// Params to call API get report
export const sectorParams = {
    [sectorTabConstants.basicMaterials]: 'Basic Materials',
    [sectorTabConstants.communicationServices]: 'Communication Services',
    [sectorTabConstants.consumerCyclical]: 'Consumer Cyclical',
    [sectorTabConstants.consumerDefensive]: 'Consumer Defensive',
    [sectorTabConstants.energy]: 'Energy',
    [sectorTabConstants.financialServices]: 'Financial Services',
    [sectorTabConstants.healthcare]: 'Healthcare',
    [sectorTabConstants.industrials]: 'Industrials',
    [sectorTabConstants.realEstate]: 'Real Estate',
    [sectorTabConstants.technology]: 'Technology',
    [sectorTabConstants.utilities]: 'Utilities',
}
